import React from "react";
import { AlertTriangle } from "lucide-react";
// CSS will automatically apply button styles

const NotEligiblePopup = ({ setShowNotEligible, setFormActive }) => {
  const handleClick = () => {
    setShowNotEligible(false);
    setFormActive(false);
  };
  
  return (
    <div className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" style={{ backgroundColor: "rgba(0,0,0,0.6)", zIndex: 1060 }}>
      <div className="backdrop-blur-md bg-white/[0.03] border border-white/10 rounded-4 p-4 text-center shadow-lg animate-up" style={{ maxWidth: "350px", width: "90%" }}>
        <div className="mb-3 text-warning">
          <AlertTriangle size={48} />
        </div>
        <h5 className="fw-bold mb-2">Eligibility Notice</h5>
        <p className="text-gray-300 mb-4 small">
          We are sorry, but based on your selection, you do not meet the residency criteria for this specific scheme.
        </p>
        <button onClick={handleClick} className="btn btn-theme rounded-pill px-4 w-100">
          Understood
        </button>
      </div>
    </div>
  );
};

export default NotEligiblePopup;
